<script lang="ts">

export default {
  name: "BigArmyWxDialog",
  props:{
    value:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:''
    }
  },
  data(){
    return {
    }
  },
  methods:{
   handleDialogClose(){
     this.$emit('input',false)
     this.$emit('close')
   }
  }
}
</script>

<template>
  <div>
     <van-dialog use-slot className="bigArmayWxDialog"  @close="handleDialogClose" v-model="value" :show-cancel-button="false" :show-confirm-button="false" customStyle="background: none;border-radius:0">
       <div>
         <div class="dialog-content">
           <div class="title">{{title}}</div>
           <slot name="content">
           </slot>
         </div>
         <div class="dialog-footer-wrapper">
           <img src="https://shuian-file.oss-cn-hangzhou.aliyuncs.com/wx/icon_close.svg" class="btn-close" @click="handleDialogClose"/>
         </div>

       </div>

    </van-dialog>
  </div>
</template>

<style lang="stylus" scoped>
.bigArmayWxDialog{
  background none
}
.dialog-content{
  background #fff;
  position relative
  color: #1D2129;
  border-radius .24rem
  .title{
    padding-top .60rem
    font-weight: 600;
    font-size: .36rem;
    font-style: normal;
    text-decoration: none;
    text-align: center;
  }

}
  .dialog-footer-wrapper{
    margin: .40rem auto 0
    display flex;
    justify-content center
    .btn-close{
      margin 0 auto
      width .64rem
      height .64rem
    }

  }

</style>
